import {FloatLabelType} from '@angular/material/form-field';
import {Structures} from 'octopus-model';
import {RolesOrDefault} from 'shared/models';

export const authenticationSettings = {
    activeChangePasswordStrategy: Structures.boolean(false),
    askForHelp: Structures.boolean(false),
    showEdito: Structures.boolean(false),
    displayLoginLogo: Structures.boolean(false),
    displayGARHelper: Structures.boolean(true),
    displayPartnersLogo: Structures.array([]),
    enableFormLogin: Structures.boolean(true),
    enableGAR: Structures.boolean(false),
    enableLocalCache: Structures.boolean(false),
    enableSSO: Structures.boolean(false),
    entButtonAllowedWithoutRules: Structures.boolean(true),
    extentedValidation: Structures.boolean(false),
    firstConnexionRedirection: Structures.object({}),
    floatLabelControl: Structures.string('auto'),
    forceGAR: Structures.boolean(false),
    forceOpenModalNotificationAutoToFalse: Structures.boolean(false),
    forceSetEmail: Structures.boolean(false),
    licenceLink: Structures.string(''),
    logoutUrlSSO: Structures.object(),
    newsletterRulesAddNoSsoUser: Structures.boolean(false),
    onlyLoginWithMail: Structures.boolean(false),
    overrideDefaultRouteByRole: Structures.object({}),
    specificRedirectionPath: Structures.string(null),
    toolsAllowedBylevel: Structures.object({
        notepad: ['trainer', 'manager', 'administrator'],
        mindmap: ['trainer', 'manager', 'administrator']
    }),
    urlGarRegister: Structures.string(''),
    urlSSO: Structures.object(),
    useUrlGarRegister: Structures.boolean(false),
    validateEmailStrategyActivated: Structures.boolean(false),
    activateAuthenticationByThirdParty: Structures.boolean(false),
    googleClientId: Structures.string(''),
    facebookAppId: Structures.string(''),
    appleRedirectUri: Structures.string(''),
    appleClientId: Structures.string(''),
    redirectLearnerToAppAfterLogin:Structures.boolean(false),
};

export type AuthenticationOverrideSettings = {
    displayPartnersLogo: { src: string, alt: string, class: string }[];
    firstConnexionRedirection: { [key in RolesOrDefault]: string };
    floatLabelControl: FloatLabelType
    overrideDefaultRouteByRole: { [key in RolesOrDefault]: string };
    redirectSignup: { url: string, target: string };
    urlSSO: { [lang: string]: string };
}